import dynamic from 'next/dynamic';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { usePathname } from '@flipster/i18n/routing';
import { useOverlay } from '@flipster/overlay';
import { Button, StatusBadge } from '@flipster/react/design-system';
import { IconButton } from '@flipster/react/design-system/icon-button';
import MenuIcon from '@flipster/react/icon/generated/MenuIcon';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { css } from '@flipster/styled-system/css';
import { token } from '@flipster/styled-system/tokens';
import segment, { SessionEvent } from '@flipster/utils/segment';

import { useRedDot } from '@web/hooks/useRedDot';

import { GnbPromotionItemFragment } from './query.generated';

// 유저에서 바로 보여지지 않기때문에 dynamic loading
const MobileDrawer = dynamic(() => import('./mobile-drawer').then((mod) => mod.MobileDrawer), { ssr: false });

const hideSignUpPage = ['/signup', '/login'];

export const MobileMenu = ({ promotion }: { promotion?: GnbPromotionItemFragment }) => {
  const pathname = usePathname();
  const { isLoggedIn } = useAuth();
  const { data: redDot } = useRedDot();
  const overlay = useOverlay();
  const isMounted = useMounted();

  const isShowRedDot = Boolean(redDot?.gnb.length);
  const isShowSignUp = isMounted && !isLoggedIn && !hideSignUpPage.includes(pathname);

  const handleMenuClick = () => {
    overlay.open((close) => <MobileDrawer onClose={close} promotion={promotion} />, 'drawer');
    segment.track(SessionEvent.GnbHamburgerClick);
  };

  return (
    <div className={css({ display: { base: 'flex', smallDesktop: 'none' }, direction: 'row', gap: 16 })}>
      {isShowSignUp && (
        <Button
          label='Sign up'
          as='a'
          href='/signup'
          size='small'
          onClick={() => segment.track(SessionEvent.GnbLoginClick, { button_text: 'Sign up' })}
        />
      )}
      <StatusBadge visible={isShowRedDot} positionType='icon'>
        <IconButton
          hierarchy='quaternary'
          icon={<MenuIcon color={token('colors.content.default.level-4')} />}
          onClick={handleMenuClick}
        />
      </StatusBadge>
    </div>
  );
};
